import { RouteObject } from "react-router-dom";
import { routeCan, routeCanAny } from "src/authentication/routeCan";
import { Action } from "src/casl/Action";

export const directoryRoutes: RouteObject[] = [
    /** As `GET /directory` asks, and the frame's People link with it */
    {
        index: true,
        lazy: () => import("./PeopleDirectoryScreen"),
        handle: routeCanAny(
            { i: Action.Manage, a: "Person" },
            { i: Action.Manage, a: "ChildProtectionClearance" }
        ),
    },

    { path: "add-person", lazy: () => import("./person/NewPersonScreen"), handle: routeCan(Action.Create, "Person") },

    {
        path: "merge-people",
        lazy: () => import("./merge-people/MergePeopleScreen"),
        handle: routeCan(Action.Manage, "Person"),
    },

    {
        path: "view-person/:personId",
        handle: routeCan(Action.Read, "Person"),
        lazy: () => import("./person/ViewPersonScreen"),
        // Each area of the index is its own route; whether it shows is the server's (PPL60, PPL63)
        children: [
            { index: true, element: null },
            { path: "contact", lazy: () => import("./person/areas/PersonContactDetailsArea") },
            { path: "family", lazy: () => import("./person/areas/PersonFamilyArea") },
            { path: "ministries", lazy: () => import("./person/areas/PersonMinistriesArea") },
            { path: "child-protection", lazy: () => import("./person/areas/PersonChildProtectionArea") },
            {
                path: "medical-notes",
                lazy: () => import("./person/medical-notes/PersonMedicalNotesTab"),
                handle: routeCan(Action.Read, "PersonMedicalNote"),
            },
            { path: "membership", lazy: () => import("./person/areas/PersonMembershipArea") },
            {
                path: "sign-in",
                lazy: () => import("./person/areas/PersonSignInArea"),
                handle: routeCan(Action.Manage, "all"),
            },
        ],
    },

    {
        path: "view-person/:personId",
        handle: routeCan(Action.Read, "Person"),
        children: [
            {
                path: "update-details",
                lazy: () => import("./person/EditPersonScreen"),
                // Manage, since a registrar may update a mobile number and nothing else
                handle: routeCan(Action.Manage, "Person"),
            },

            {
                path: "membership/application",
                lazy: () => import("./person/memberships/management/application/MembershipApplicationScreen"),
            },
        ],
    },
];
